<template>
  <v-layout column id="end">
    <v-card class="intro-dark mx-5">
      <v-card-title
        class="intro-header justify-center"
        style="line-height: 1.2em"
      >
        <mrx-translation
          token="app.end.title"
          class="full-word text-center"
        ></mrx-translation>
      </v-card-title>
      <v-card-text
        class="white--text intro-body text-center pb-0"
        style="line-height: 1.2em"
      >
        <mrx-translation token="app.end.new_assessment_preferences.instructions"></mrx-translation>
      </v-card-text>
      <v-card-actions class="pa-5">
        <v-btn
          block
          @click="navigate"
          id="new-assessment-button"
          x-large
          class="white--text"
        >
          <mrx-translation token="app.end.new_assessment_preferences.button"></mrx-translation>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-layout>
</template>

<script>
import languageLogic from "@/mixins/languageLogic"
import mrx from "@/mixins/mrx"

export default {
  name: "End",
  mixins: [languageLogic, mrx],
  mounted() {
    this.recordsInQueue();
  },
  methods: {
    async navigate() {
      await this.$store.dispatch("v4/observation/reset", { force: true })
      await this.$store.dispatch("v4/startId/new")

      const locations = this.$store.getters['v4/location/rootLocations'];
      const hasLocations = locations && locations.length > 0;
      const selectionsComplete = this.$store.getters['v4/location/selectionsComplete'];

      if (hasLocations && !selectionsComplete) {
        this.$router.push({ path: '/location' })
      } else {
        this.$router.push({ path: "/preference/summary" })
      }
    },
  },
};
</script>
